export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7748.bec5f139.jpg";